import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { getLink } from "../../dataProvider/links.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimes, faCheck, faPencilAlt, faLock } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux'
import SquareContainer from './SquareContainer.jsx';
import { updateUser, reloadUser } from "../../actions/user.js"
import { getCloudFiles } from '../../actions/file.js';
import { error as logError } from "../../logger.js";
import UnsubscribeBlock from "../util/UnsubscribeBlock.jsx";

import emailIconV2 from "../../img/v2/contact/email.png"
import fileConvertedV2 from "../../img/v2/user/file-converted.png";
import commitmentIconV2 from "../../img/v2/user/commitment.png";
import accountIconV2 from "../../img/v2/user/unsubscribe-icon.png"

import "../../scss/v2/user/manageAccount.scss"

function ManageAccount(props) {

    const { t, i18n } = useTranslation();
    const [cloudUsageRate, setCloudUsageRate] = useState(0)
    const [updateEmail, setUpdateEmail] = useState(false)
    const [email, setEmail] = useState(null)
    const [error, setError] = useState(false)
    const [product, setProduct] = useState({});
    let navigate = useNavigate();

    useEffect(() => {
        if (!props.user || !props.user.connected) return navigate(getLink('login', i18n.language));
        i18n.changeLanguage(props.lang)
        if (props.products[0] && !product.id) setProduct(props.products[0])
    }, [i18n, props.lang, navigate, props.user, props.products, product.id])

    useEffect(() => {
        async function loadCloudData() {
            try {
                await props.dispatch(getCloudFiles())
            } catch (error) {
                logError(error)
            }
        }
        loadCloudData()
    }, [])

    useEffect(() => {
        setCloudUsageRate(Math.floor((props.cloud.usage * 100) / props.cloud.maxUsage.size))
    }, [props.cloud])

    const handleSubmit = () => {
        setError(false)
        return props.dispatch(updateUser({ id: props.user.id, email }))
            .then(() => {
                props.dispatch(reloadUser())
            })
            .then(() => {
                setUpdateEmail(false)
            })
            .catch(err => {
                setError(true)
                logError(err)
            })
    }

    return (
        <div className="manage-account container">
            <h1 className="manage-account-title">{t('manageAccount.title')}</h1>
            <SquareContainer>
                <div className="row">
                    <div className="col-12 col-md-10 offset-md-1">
                        <h2 className="user-square-container-title text-center">{t('manageAccount.topCard.title')}</h2>
                        <div className="row">
                            <div className="col-12 col-lg-5 text-left">
                                <div className="manage-account-topCard-element">
                                    <p className="manage-account-topCard-green-title">{t('manageAccount.topCard.emailElement.title')}</p>
                                    {error ? (<div className='alert alert-danger mb-3' >{t(`contact.message.error.${error}`)}</div>) : null}
                                    <div className="manage-account-icon-text-container">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <img className="img img-fluid manage-account-icon" src={emailIconV2} alt={emailIconV2} />
                                            </div>
                                        </div>
                                        {updateEmail ?
                                            (<input className="manage-account-input" placeholder={t('manage.account.placeholder.email')} onChange={(event) => { setEmail(event.target.value) }} />) :
                                            (<p className="manage-account-text">{props.user.email}</p>)
                                        }
                                        <div className="manage-account-editIcon-container">
                                            {updateEmail ?
                                                (<div className="manage-account-editIcon-subcontainer" onClick={handleSubmit}>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </div>) :
                                                (<div className="manage-account-editIcon-subcontainer" onClick={() => { setUpdateEmail(true) }}>
                                                    <FontAwesomeIcon icon={faPencilAlt} />
                                                </div>)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="manage-account-topCard-element">
                                    <p className="manage-account-topCard-green-title">{t('manageAccount.topCard.passwordElement.title')}</p>
                                    <div className="manage-account-icon-text-container">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <FontAwesomeIcon icon={faLock} />
                                            </div>
                                        </div>
                                        <p className="manage-account-text">{props.user?.metadata?.biblio?.password}</p>
                                        <div className="manage-account-editIcon-container">
                                            <div className="manage-account-editIcon-subcontainer">
                                                <Link to={getLink("passwordChange", i18n.language)}>
                                                    <FontAwesomeIcon icon={faPencilAlt} />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="manage-account-topCard-element">
                                    <p className="manage-account-topCard-green-title">{t('manageAccount.topCard.fileElement.title')}</p>
                                    <div className="manage-account-icon-text-container">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <img className="img img-fluid manage-account-icon" src={fileConvertedV2} alt={fileConvertedV2} />
                                            </div>
                                        </div>
                                        <p className="manage-account-text">{t('manageAccount.topCard.fileElement.text', { cloudUsageRate })}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-2">
                                <div className="manage-account-topCard-element">
                                    <div className="manage-account-topCard-separator"></div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-5 text-left">
                                <div className="manage-account-topCard-element">
                                    <p className="manage-account-topCard-green-title">{t('manageAccount.topCard.planElement.title')}</p>
                                    <p className="manage-account-topCard-text mb-4">{t('manageAccount.topCard.planElement.trial', { acqPrice: product.acqPrice, subPrice: product.subPrice })}</p>
                                </div>
                                <div className="manage-account-topCard-element">
                                    <p className="manage-account-topCard-green-title">{t('manageAccount.topCard.statusElement.title')}</p>
                                    {
                                        (props.subscription.subscribed && props.user.status === 'ok') ?
                                            <div className="manage-account-topCard-text">
                                                {t('manageAccount.topCard.statusElement.active.text')}
                                                <div className="status-element-info">
                                                    <FontAwesomeIcon icon={faCheck} />
                                                    <span>{t('manageAccount.topCard.statusElement.active.info')}</span>
                                                </div>
                                            </div> :
                                            <div className="manage-account-topCard-text">
                                                {t('manageAccount.topCard.statusElement.inactive.text')}
                                                <div className="status-element-info inactive">
                                                    <FontAwesomeIcon icon={faTimes} />
                                                    {t('manageAccount.topCard.statusElement.inactive.info')}
                                                </div>
                                            </div>
                                    }
                                    <div className="manage-account-icon-text-container green-text">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <img className="img img-fluid manage-account-commitment-icon" src={commitmentIconV2} alt={commitmentIconV2} />
                                            </div>
                                        </div>
                                        <p className="manage-account-text">{t('manageAccount.topCard.commitmentIcon.text')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SquareContainer>
            <div className="account">
                <div className="row">
                    <div className="col-12 col-lg-8 offset-lg-2 text-center">
                        <div className="row">
                            <div className="col-12 col-md-8 offset-md-2 col-lg-12 offset-lg-0 mb-5" >
                                <div className="account-card">
                                    <UnsubscribeBlock />
                                </div>
                            </div>
                            <div className="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-0">
                                <div className="account-card">
                                    <h2 className="account-card-title">{t('manageAccount.manageCard.title')}</h2>
                                    <img className="img img-fluid account-card-image" src={accountIconV2} alt={accountIconV2} />
                                    <p className="account-card-text">{t('manageAccount.manageCard.text')}</p>
                                    <Link to={getLink('unsubscribe', i18n.language)}>
                                        <button className="button orange-button">{t('manageAccount.manageCard.button')}</button>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-0">
                                <div className="account-card">
                                    <h2 className="account-card-title">{t('manageAccount.accountCard.title')}</h2>
                                    <div className="manage-account-icon-text-container">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <FontAwesomeIcon icon={faCheckCircle} />
                                            </div>
                                        </div>
                                        <p className="manage-account-text">{t('manageAccount.accountCard.element.1')}</p>
                                    </div>
                                    <div className="manage-account-icon-text-container">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <FontAwesomeIcon icon={faCheckCircle} />
                                            </div>
                                        </div>
                                        <p className="manage-account-text">{t('manageAccount.accountCard.element.2')}</p>
                                    </div>
                                    <div className="manage-account-icon-text-container">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <FontAwesomeIcon icon={faCheckCircle} />
                                            </div>
                                        </div>
                                        <p className="manage-account-text">{t('manageAccount.accountCard.element.3')}</p>
                                    </div>
                                    <div className="manage-account-icon-text-container">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <FontAwesomeIcon icon={faCheckCircle} />
                                            </div>
                                        </div>
                                        <p className="manage-account-text">{t('manageAccount.accountCard.element.4')}</p>
                                    </div>
                                    <div className="manage-account-icon-text-container">
                                        <div className="manage-account-icon-container">
                                            <div className="manage-account-icon-subcontainer">
                                                <FontAwesomeIcon icon={faCheckCircle} />
                                            </div>
                                        </div>
                                        <p className="manage-account-text">{t('manageAccount.accountCard.element.5')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

const mapStateToProps = state => ({ subscription: state.user.subscription, user: state.user.user, products: state.product.products, cloud: state.user.cloud })

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(ManageAccount);